import React from "react";
import { Modal, Row, Col, Button } from "antd";
import { strings } from "../../helpers";

export default class ViewNotesModalView extends React.Component {
  render() {
    const { showNotesModal, toggleNotesModal, notes } = this.props;
    return (
      <div>
        <Modal
          title={strings.referrals.referralNotes}
          visible={showNotesModal}
          footer={null}
          onOk={toggleNotesModal}
          onCancel={toggleNotesModal}
        >
          <p>{notes || strings.referrals.noReferralNotes}</p>
          <Row className="modal-footer-row">
            <Col className="text-right">
              <Button type="primary" size="small" onClick={toggleNotesModal}>
                {strings.tickets.close}
              </Button>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}
